import { downloadFile } from 'common/utils/helpers';

import getFile from './getFile';

export default (fileName) => (dispatch) => {
    dispatch(getFile(fileName, (data) => downloadFile(data?.url, fileName)));
};
